import { getToken } from '@/api/Chat/getToken';
import { Client, Message, Conversation } from '@twilio/conversations';
import moment from 'moment';

export type UserDetails = {
  id: number;
  name: string;
  image: string;
};
export type ChatUserTypes = {
  sender: UserDetails;
  receiver: UserDetails;
};
export type MessageListType = {
  message: string;
  sendedType: 'sent' | 'received';
  time: string;
  fileName: string;
  messageTime: string;
  author: string;
  seen: boolean;
  videoThumbnail: string;
  type: string;
};
export const clientInitializer = async (): Promise<Client> => {
  try {
    const response = await getToken();
    const twiilioClient = new Client(response.token);
    return twiilioClient;
  } catch (err) {
    console.error('Error in clientInitializer:', err);
    throw err;
  }
};

export const getCurrentUserDetails = async (conversation: Conversation, userId: string | null) => {
  let details: ChatUserTypes = {
    sender: {
      id: 0,
      name: '',
      image: '',
    },
    receiver: {
      id: 0,
      name: '',
      image: '',
    },
  };
  const participants = await conversation.getParticipants();
  for (let i = 0; i < participants.length; i++) {
    const { state }: any = participants[i];
    if (state?.identity == userId) {
      details.receiver = state?.attributes;
    } else {
      details.sender = state?.attributes;
    }
  }
  return details;
};
export const getMessageListing = async (
  conversation: Conversation,
  userId: string | null,
  pageSize: number = 20,
  pageNumber: number = 1
) => {
  if (pageSize <= 0 || isNaN(pageSize)) {
    console.error('Invalid pageSize, defaulting to 20');
    pageSize = 20;
  }

  if (pageNumber <= 0 || isNaN(pageNumber)) {
    console.error('Invalid pageNumber, defaulting to 1');
    pageNumber = 1;
  }

  const messages: MessageListType[] = [];
  const totalMessage = await conversation.getMessagesCount();
  const startIndex = (pageNumber - 1) * pageSize;

  // const list = await conversation.getMessages(totalMessage, 1, 'forward');
  const list = await conversation.getMessages(pageSize, startIndex, 'forward');

  const items = list?.items || [];
  for (let i = 0; i < items.length; i++) {
    const { state }: any = items[i];
    const { author, body, timestamp, attributes, type } = state;
    const data = JSON.parse(body);
    messages.push({
      message: data?.message,
      sendedType: author == userId ? 'received' : 'sent',
      time: moment(timestamp).format('h:mm A'),
      fileName: data?.fileName,
      videoThumbnail: data?.videoThumbnail,
      messageTime: formatMessageTime(timestamp),
      author: author,
      seen: data?.seen || false,
      type: data?.type,
      // time: moment(timestamp)?.fromNow(),
    });
  }
  return messages;
};

export const connectionStateNotifyer = (client: Client) => {
  try {
    client.on('connectionStateChanged', (state) => {
      if (state === 'connecting') {
      }
      if (state === 'connected') {
      }
      if (state === 'disconnecting') {
      }
      if (state === 'disconnected') {
      }
      if (state === 'denied') {
      }
      return state;
    });
  } catch (err) {}
};

export const getConversations = (client: Client) => {
  try {
    const consavatin = new Promise((resolve, reject) => {
      client.on('conversationJoined', (conversation) => {
        resolve(conversation);
      });
    });
    return consavatin;
  } catch (err) {
    console.log('Fatching failed :-', err);
  }
};

export const formatMessageTime = (messageTime: string | number | Date) => {
  const messageMoment = moment(messageTime).local();
  const currentMoment = moment().local();
  if (messageMoment.isSame(currentMoment, 'day')) {
    return 'Today';
  }
  if (messageMoment.isSame(currentMoment.subtract(1, 'days'), 'day')) {
    return 'Yesterday';
  }
  if (messageMoment.isSame(currentMoment, 'week')) {
    return messageMoment.format('dddd');
  }
  return messageMoment.format('DD MMM YYYY');
};

// const formatMessageTime = (messageTime: string | number | Date) => {
//   const messageDate = new Date(messageTime);

//   const currentDate = new Date();
//   currentDate.setMinutes(currentDate.getMinutes() + currentDate.getTimezoneOffset() + 330); // Adjust to IST

//   if (messageDate.toDateString() === currentDate.toDateString()) {
//     return messageDate.toLocaleTimeString([], {
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true,
//     });
//   }

//   const yesterday = new Date(currentDate);
//   yesterday.setDate(currentDate.getDate() - 1);
//   if (messageDate.toDateString() === yesterday.toDateString()) {
//     return (
//       'Yesterday at ' +
//       messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })
//     );
//   }

//   const messageWeekStart = new Date(messageDate);
//   messageWeekStart.setDate(messageDate.getDate() - messageDate.getDay());
//   const currentWeekStart = new Date(currentDate);
//   currentWeekStart.setDate(currentDate.getDate() - currentDate.getDay());

//   if (
//     messageWeekStart.toDateString() >= currentWeekStart.toDateString() &&
//     messageDate.getFullYear() === currentDate.getFullYear()
//   ) {
//     return messageDate.toLocaleString('en-US', { weekday: 'long' }); // Day of the week
//   }

//   return messageDate.toLocaleDateString('en-GB'); // Format as DD/MM/YYYY
// };

// markMessageAsUnseen(newMessage.sid, newMessage.conversationSid);

// export const markMessageAsSeen = async (messageSid: string, conversationSid: string) => {
//   try {
//     const conversation = await client.getConversationBySid(conversationSid);
//     const message = await conversation.getMessageBySid(messageSid);

//     // You can update the message's custom attributes to mark it as read
//     await message.update({ attributes: { ...message.attributes, seen: true } });

//     console.log(`Message ${messageSid} marked as seen.`);
//   } catch (error) {
//     console.error("Error marking message as seen:", error);
//   }
// };
